@if (story() && layout()) {
    <app-blog-category-wrapper [block]="story()!.content"
                              [layout]="layout()!" />
} @else {
    <h1>404</h1>
    <p>Your story is gone</p>
}
